import { openBlock, createElementBlock, createElementVNode } from "vue";
import _export_sfc from "../uikit._virtual/_plugin-vue_export-helper.es.js";
const _sfc_main = {};
const _hoisted_1 = {
  width: "25",
  height: "20",
  viewBox: "0 0 16 16",
  fill: "currentColor",
  stroke: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  d: "M8 9C8.55228 9 9 8.55228 9 8V1C9 0.447719 8.55228 0 8 0C7.44772 0 7 0.447719 7 1V8C7 8.55228 7.44772 9 8 9Z",
  fill: "currentColor"
}, null, -1);
const _hoisted_3 = /* @__PURE__ */ createElementVNode("path", {
  opacity: "0.4",
  d: "M12.5562 2.04197C12.075 1.67375 11.3715 1.83872 11.0802 2.36997L10.8362 2.81497C10.6006 3.24465 10.7179 3.77422 11.1021 4.0784C12.2894 5.01828 13.0001 6.4575 13.0001 8.00047C13.0001 11.1932 9.99146 13.697 6.66058 12.8253C5.1623 12.4333 3.90968 11.3117 3.35243 9.86675C2.51105 7.68456 3.23652 5.39793 4.89205 4.08315C5.27815 3.77653 5.40046 3.24637 5.1634 2.814L4.92036 2.37072C4.62836 1.83819 3.92318 1.6749 3.44105 2.04422C1.17549 3.77975 0.0251136 6.71115 0.684957 9.66678C1.39596 12.8517 4.21627 15.258 7.4718 15.4822C11.8455 15.7834 15.5001 12.311 15.5001 8.00047C15.5001 5.64397 14.3951 3.44918 12.5562 2.04197Z",
  fill: "currentColor"
}, null, -1);
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
];
function _sfc_render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_4);
}
const LogoutIcon = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export {
  LogoutIcon as default
};
//# sourceMappingURL=LogoutIcon.vue.es.js.map
